import { Table, Input, Tag, Space, Popover, Cascader, Row, Col, Spin, Typography, Popconfirm, notification } from 'antd';
import { CheckCircleFilled, FilterOutlined, SyncOutlined, LoadingOutlined, CloseCircleFilled } from '@ant-design/icons';
import React, { useEffect, useMemo, useState } from 'react';
import { StyledButton } from 'src/styled_components/StyledButton';
// import type { GetProps } from 'antd'; // Removed because 'GetProps' does not exist in 'antd'
import "./PredictionHistory.scss";
import { useHistory } from 'react-router-dom';
import useTranslate, { LanguageUnion } from 'src/utils/useTranslate';
import { useDispatch, useSelector } from 'react-redux';
import { AsyncStates } from 'src/constants';
import { StoreState } from 'src/store/configureStore';
import { deletePredictionHistoryCleanup, deletePredictionHistoryRequest, getPredictExperimentCleanup, getPredictionHistoryListRequest } from 'src/store/actions/extrapolation';
import { useMemberName } from 'src/utils/useMemberName';
import dayjs from 'dayjs';
import StyledDeleteIcon from 'src/styled_components/StyledDeleteIcon';
import { Unsubscribe, doc, onSnapshot } from "firebase/firestore";
import { firestoreDb } from 'src/utils/firebase';
import { messages } from 'src/utils/hooks';



const { Search } = Input;

type SearchProps = React.ComponentProps<typeof Input.Search>;

interface PredictionHistoryProps {
    setPredHistExtrapolationTitle: React.Dispatch<React.SetStateAction<string>>;
    pagination: { current: number, pageSize: number };
    setPagination: React.Dispatch<React.SetStateAction<{ current: number, pageSize: number }>>;
}
const PredictionHistory: React.FC<PredictionHistoryProps> = (props: PredictionHistoryProps) => {
    const { setPredHistExtrapolationTitle, pagination, setPagination } = props;
    const { push } = useHistory();
    const [t] = useTranslate();
    const dispatch = useDispatch()
    const { getName } = useMemberName()
    const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false)
    const [filterSelections, setFilterSelections] = useState<any[]>([])
    const [searchText, setSearchText] = useState<string>("")
    const [searchValue, setSearchValue] = useState<string>("");
    const [filters, setFilters] = useState<any>({})
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    const [deletePredictionIds, setDeletePredictionIds] = useState<any[]>([]);
    const teams = useSelector((state: StoreState) => state.teams.data)
    const ln: LanguageUnion = useSelector(
        (state: StoreState) => state.language.current
    );
    const { predictionHistoryListStatus, predictionHistoryList, totalPredHistoryCount, statusDeletePredictionIds,predictExprimentData, predictExprimentStatus } = useSelector((state: StoreState) => state.extrapolation);

    const options: any[] = useMemo(() => [
        {
            value: "user_ids",
            label: 'User',
            children: teams?.map((res: any) => ({
                value: res.user_id,
                label: res?.user_name,
            })),
        }, 
    ], [teams]);

    const columns = useMemo(() => [
        {
            title: 'Prediction Title',
            dataIndex: 'title',
        },
        // {
        //     title: 'Data Source',
        //     render: ()=> "Work Order",
        // },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (text: string) => {
                if (text === "in_progress") {

                    return (
                        <Tag icon={<SyncOutlined spin />} color="blue">
                            {"In Progress"}
                        </Tag>
                    );

                } else if (text === "no_results_found") {
                    return (
                        <Tag icon={<CheckCircleFilled />} color="orange">
                            {"No Result Found"}
                        </Tag>
                    );
                } else if (text === "failed") {
                    return (
                        <Tag icon={<CloseCircleFilled />} color="red">
                            {"Failed"}
                        </Tag>
                    );
                } else {
                    return (
                        <Tag icon={<CheckCircleFilled />} color="green">
                            {"Completed"}
                        </Tag>
                    );
                }
            }
        },
        {
            title: 'Project',
            dataIndex: 'project_names',
        },
        {
            title: 'Requested On',
            dataIndex: 'requestedOn',
            render: (text: any, record: any) => {
                return <Typography.Text>{
                    dayjs(text).format('DD MMM YYYY HH:mm')
                }</Typography.Text>
            }
        },
        {
            title: 'Created By',
            dataIndex: 'createdBy',
        },
    ], []);

    const onSearch: SearchProps['onSearch'] = (value: any, _e: any, info: any) => {
        //console.log(info,"sime" ,value,"some",_e,"srachtext");
        setPagination((prev) => ({ ...prev, current: 1 }))
        setSearchValue(value)
    }


    function pageChange(pageNum: number, pageSize: number) {
        setPagination({ current: pageNum, pageSize })
    }

    const applyFilters = (values: any) => {
        let interimPayload: { [key: string]: string[] } = {}
        for (const value of values) {
          if (value.length === 1) {
            interimPayload[value[0]] = options
              .find((op) => op.value === value[0])
              .children.map((child: any) => child.value)
          }
          if (value.length === 2) {
            if (interimPayload[value[0]]) {
              interimPayload[value[0]].push(value[1])
            } else {
              interimPayload[value[0]] = [value[1]]
            }
          }
        }

        const { status, user_ids, project_ids, model_type } = interimPayload

        const payload = {
            filters: user_ids ? [{ value_type: "list", field: "user_id", operand: "in", min_value: user_ids }] : [],
            model_type: model_type || [],
            status: status || [],
            project_ids: project_ids || []
        }

        setFilters(payload);
        setPagination((prev) => ({ ...prev, current: 1 }));
        setIsFilterOpen(false);
    }

    const clearFilters = () => {
        setFilters([]);
        setFilterSelections([]);
        setIsFilterOpen(false);
    }

    const normalizedData = useMemo(() => {
        return predictionHistoryList.map((item: any, idx: number) => {
            // If title is at top level, use it; else, get from data.title
            const title = item?.title ?? item?.data?.title ?? "";
            const project = item?.project_name ?? item?.data?.project_name ?? "";
            const requestedOn = item?.created ?? item?.data?.created ?? "";
            const createdBy = getName(item?.user_id) ?? getName(item?.data?.user_id) ?? item?.data?.user_id ?? "";
            const status = item?.status ?? item?.data?.status ?? "";
            // Add a unique key
            return {
                ...item,
                title,
                project,
                requestedOn,
                createdBy,
                status,
                key: idx,
            };
        });
    }, [getName, predictionHistoryList]);


    useEffect(() => {
        let payload: {
            page_num: number;
            page_size: number;
            filters: any;
            search_term?: string;
        } = {
            page_num: pagination.current,
            page_size: pagination.pageSize,
            ...filters
        };
        //console.log(searchValue,"serachValue");
        if (searchValue?.trim()?.length > 0) {
            payload['search_term'] = searchValue
        }
        dispatch(getPredictionHistoryListRequest({ payload }))

    }, [dispatch, filters, pagination, searchValue])

    const deletePredictions = () => {
        dispatch(deletePredictionHistoryRequest({ payload: { prediction_ids: deletePredictionIds } }))
    }

    useEffect(() => {
        if (statusDeletePredictionIds === AsyncStates.SUCCESS) {
            setPagination((prev) => ({ ...prev, current: 1 }))
            setSelectedRowKeys([])
            setDeletePredictionIds([])
            dispatch(deletePredictionHistoryCleanup())

        }
    }, [statusDeletePredictionIds, dispatch, setPagination])

    // added notification on pred hsitory screen and refresh api
    // to show comleted predictions
    useEffect(() => {
        let unsub: Unsubscribe
        const listenToDataSaveTaskStatus = async () => {
          const taskDocRef = doc(firestoreDb, `${predictExprimentData?.firestore_collection}/${predictExprimentData?.prediction_id}`)
          unsub = onSnapshot(taskDocRef, (doc) => {
            const taskDoc = doc.data()
           // console.log(taskDoc, 'taskDoc1',predictExprimentData)
            if (taskDoc && taskDoc?.status === "finished") {
                //console.log(taskDoc, 'taskDoc2')
                notification.success({
                    message: messages[ln].beyesianPredCompleted,
                    duration: 5,
                })
                dispatch(getPredictExperimentCleanup())
                let payload = { page_num: pagination.current, page_size: pagination.pageSize }
                dispatch(getPredictionHistoryListRequest({payload}))
                unsub()
            }
           
          })
        }
        //console.log(predictExprimentStatus, 'predictExprimentStatus')
        if(predictExprimentData && predictExprimentData?.prediction_id){
                listenToDataSaveTaskStatus()
        }

        return () => {
            unsub && unsub()
        }
      }, [dispatch, ln, pagination, predictExprimentData, predictExprimentStatus])


    return (
        <Spin spinning={predictionHistoryListStatus === AsyncStates.LOADING} indicator={<LoadingOutlined />}>
            <Space direction="vertical" style={{ width: '100%', padding: '24px 0' }}>
                {/* Search and Filter Row */}
                <Space style={{ justifyContent: 'space-between', width: '100%' }}>
                    <Search placeholder="input search text" value={searchText} onChange={(e) => setSearchText(e.target.value)} allowClear onSearch={onSearch} style={{ width: 320 }} />
                    <Space>
                        <Popconfirm
                            title={`${t("common.delete")} ${t("aiEngine.selectedRecords")}`}
                            icon={<StyledDeleteIcon />}
                            okText={t("common.confirm")}
                            cancelText={t("common.cancel")}
                            onConfirm={() => deletePredictions()}
                        >
                            <StyledButton
                                loading={
                                    statusDeletePredictionIds === AsyncStates.LOADING
                                }
                                icon={<StyledDeleteIcon />}
                                disabled={deletePredictionIds?.length <= 0}
                            >
                                {t("aiEngine.deleteRecords")}
                            </StyledButton>
                        </Popconfirm>
                        <Popover
                            content={
                                <Space direction="vertical">
                                    <Cascader.Panel
                                        multiple
                                        options={options}
                                        onChange={(value: any, selections: any) => {
                                            setFilterSelections(value);

                                        }}
                                        value={filterSelections}
                                        style={{ maxHeight: '300px', overflow: "auto" }}
                                    />
                                    <Row justify="end" gutter={16}>
                                        <Col>
                                            <StyledButton
                                                type="primary"
                                                onClick={() => {
                                                    applyFilters(filterSelections)
                                                }}
                                            >
                                                {t("aiEngine.button.apply")}
                                            </StyledButton>
                                        </Col>
                                        <Col>
                                            <StyledButton onClick={() => clearFilters()} type="dashed">
                                                {t("common.clear")}
                                            </StyledButton>
                                        </Col>
                                    </Row>
                                </Space>
                            }
                            placement="bottomLeft"
                            trigger={"click"}
                            open={isFilterOpen}
                            onOpenChange={(visible) => setIsFilterOpen(visible)}
                        >
                            <StyledButton
                                icon={<FilterOutlined />}
                                className={isFilterOpen ? "action-button-active" : ""}
                            >
                                {t("common.filters")}
                            </StyledButton>
                        </Popover>
                    </Space>
                </Space>

                {/* Table */}
                <Table
                    className='prediction-history-table'
                    rowSelection={{
                        selectedRowKeys,
                        onChange: (ids) => {
                            setSelectedRowKeys(ids as string[])
                            let predId: any[] = []
                            ids.forEach((id: any) => {
                                let predid = normalizedData[id]?.prediction_id ?? normalizedData[id]?.data?.prediction_id
                                predId.push(predid)
                            })
                            setDeletePredictionIds(predId)
                        },
                        getCheckboxProps: (record) => ({
                            disabled: record?.status === "in_progress" || record?.data?.status === "in_progress"
                        })
                    }}
                    columns={columns}
                    dataSource={normalizedData}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        showSizeChanger: true,
                        responsive: true,
                        position: ["bottomRight"],
                        total: totalPredHistoryCount,
                        onChange: pageChange
                    }}
                    onRow={(record) => {
                        return {
                            onClick: () => {
                                setPredHistExtrapolationTitle(record?.title ?? record?.data?.title)
                                push(
                                    `/ai-engine/extrapolation/prediction_history?extrapolationId=${record?.prediction_id ?? record?.data?.prediction_id}`,
                                )
                            },
                            style: { cursor: "pointer" },
                        }
                    }}
                    style={{ marginTop: 16 }}
                />
            </Space>
        </Spin>
    );
}

export default PredictionHistory;
